<script>
	import MainPage from './MainPage.svelte';
	import ConfigPage from './ConfigPage.svelte';
  import { createEventDispatcher } from "svelte";

  const { config, consent, ref } = $$props;

  const mainData = config.mainCategories.map(({ key, disabled, label, details, preSelected }) => ({
    label,
    key,
    preSelected,
    disabled,
    details,
    value: ref.hasValidPrivacyConsent() ? consent[key] : undefined,
    toggleLabel: config.toggleLabel
  }));

  const dispatch = createEventDispatcher();

  const onConfirmSelection = ({ target }) => {
    const buttonId = target.id;

    dispatch(
      "submit",
      {
        buttonId,
        "consent": merge(mainData.map(element => ({ [element.key]: element.value || false })))
      }
    );

    dispatch(
      "click",
      {
        buttonId
      }
    );
  };

  const onSelectAll = ({ target }) => {
    const buttonId = target.id;

    dispatch(
      "submit",
      {
        buttonId,
        "consent": merge(config.mainCategories.map(({ key }) => ({ [key]: true })))
      }
    );

    dispatch(
      "click",
      {
        buttonId
      }
    );
  };

  const onReject = ({ target }) => {
    const buttonId = target.id;

    dispatch(
      "submit",
      {
        buttonId,
        "consent": merge(config.mainCategories.map(({ key }) => ({ [key]: key==='technical' })))
      }
    );
  };

  const merge = data => {
    let obj = {};
    data.forEach(element => {
      obj = {
        ...obj,
        ...element
      };
    });
    return obj;
  };

  let page = config.advancedPageFlow ? 'MainPage' : 'ConfigPage' ;

  const onGoToConfig = () => {
    page = 'ConfigPage';
  };

  const onGoBack = () => {
    page = 'MainPage';
  };
</script>

{#if page === 'MainPage'}
  <MainPage {config} {onSelectAll} {onReject} {onGoToConfig} />
{:else}
  <ConfigPage {config} {mainData} {onGoBack} {onSelectAll} {onConfirmSelection} {onReject} {onGoToConfig} />
{/if}